module.exports = __webpack_public_path__ + "img/main-bio-1-1.4cc4b152.jpg";